import './App.css';
import {BrowserRouter, Route, Switch} from "react-router-dom";
import Report from "./Componet/Report";
import Welcome from "./Componet/Welcome";
import Execute from "./Componet/Execute";
import Uti from "./Componet/Uti";
import RAG from "./Componet/RAG";
import Expire from "./Componet/Expire";
import Heading2 from "./Componet/Heading2";
import Report7day from "./Componet/Report7day";
import Reportsevenday from "./Componet/Reportsevenday";
import Nav from "./Componet/Nav";
import TruckAllocation from "./Componet/TruckAllocation";
import OrderCU from "./Componet/OrderCU";
import Allocate from "./Componet/Allocate";
import AllocateCU from "./Componet/AllocateCU";
import Status from "./Componet/Status";
import Stoppage from "./Componet/Stoppage";
import Station from "./Componet/Station";
import Rvehiclestatus from "./Componet/Rvehiclestatus";
import Rordersummury from "./Componet/Rordersummury";
import AMTransport from "./Componet/AMTransport";
import AMVehicle from "./Componet/AMVehicle";
import AMDriver from "./Componet/AMDriver";
import AMTrailer from "./Componet/AMTrailer";
import AMLocation from "./Componet/AMLocation";
import AMRoadRoute from "./Componet/AMRoadRoute";
import AMCargo from "./Componet/AMCargo";
import AMAssignment from "./Componet/AMAssignment";
import Reporttest from "./Componet/Reporttest";
import DPBTrip from "./Componet/DPBTrip";
import DPBVio from "./Componet/DPBVio";
import OrderReport from "./Componet/OrderReport";
import AllocationReport from "./Componet/AllocationReport";
import DashOrder from "./Componet/Dashboard/DashOrder";
import DashVehicleStatus from "./Componet/Dashboard/DashVehicleStatus";
import FrightReport from "./Componet/FrightReport";
import Dashboard1 from "./Componet/Dashboard/Dashboard1";
import Dashboard2 from "./Componet/Dashboard/Dashboard2";
import Dashboard3 from "./Componet/Dashboard/Dashboard3";
import Type from "./Componet/Type";
import Login from "./Componet/Login";
import User from "./Componet/User";
import ObjUser from "./Componet/ObjUser";
import UserAccess1 from "./Componet/UserAccess1";
import UserAccess2 from "./Componet/UserAccess2";
import Order from "./Componet/Order/Order";
import Order_change_date from "./Componet/Order/Order_change_date";
import Order_change_cargo from "./Componet/Order/Order_change_cargo";
import Order_change_volume from "./Componet/Order/Order_change_volume";
import Order_change_sale_type from "./Componet/Order/Order_change_sale_type";
import Allocate_allocate_vehicle from "./Componet/Allocation/Allocate_allocate_vehicle";
import Allocate_unallocate_vehicle from "./Componet/Allocation/Allocate_unallocate_vehicle";
import Allocate_date from "./Componet/Allocation/Allocate_date";
import Allocate_cost_manage from "./Componet/Allocation/Allocate_cost_manage";
import Allocate_cost_approval from "./Componet/Allocation/Allocate_cost_approval";
import Allocate_cost_report from "./Componet/Allocation/Allocate_cost_report";
import Allocate_weight from "./Componet/Allocation/Allocate_weight";
import Allocate_unload from "./Componet/Allocation/Allocate_unload";
import Allocate_extend_trip_req from "./Componet/Trip_Extender/Allocate_extend_trip_req";
import Allocate_extend_trip_approval from "./Componet/Trip_Extender/Allocate_extend_trip_approval";
import Allocate_extend_trip_report from "./Componet/Trip_Extender/Allocate_extend_trip_report";
import Follow_up_allocated_veh from "./Componet/follow_up/Follow_up_allocated_veh";
import Follow_up_to_load_veh from "./Componet/follow_up/Follow_up_to_load_veh";
import Follow_up_load_veh from "./Componet/follow_up/Follow_up_load_veh";
import Follow_up_departure_veh from "./Componet/follow_up/Follow_up_departure_veh";
import Follow_up_to_unload_veh from "./Componet/follow_up/Follow_up_to_unload_veh";
import Follow_up_unload_veh from "./Componet/follow_up/Follow_up_unload_veh";
import Open_order_status from "./Componet/Status/Open_order_status";
import Close_order_status from "./Componet/Status/Close_order_status";
import Allocation_status from "./Componet/Status/Allocation_status";
import Movement_status from "./Componet/Status/Movement_status";
import Movement_by_allocationveh from "./Componet/Status/Movement_by_allocationveh";
import Allocate_allocate_vehicle_v2 from "./Componet/Allocation/Allocate_allocate_vehicle_v2";
import Allocate_cost_mgt_v2 from "./Componet/Allocation/Allocate_cost_mgt_v2";
import Allocate_cost_approve_v2 from "./Componet/Allocation/Allocate_cost_approve_v2";
import Follow_up_status from "./Componet/follow_up/Follow_up_status";
import Follow_up_report from "./Componet/follow_up/Follow_up_report";
import Date_V2 from "./Componet/follow_up/Date_V2";
import Allocate_change_route from "./Componet/Allocation/Allocate_change_route";
import Follow_up_finish from "./Componet/follow_up/Follow_up_finish";
import Rep_trip_master from "./Componet/Report/Rep_trip_master";
import Rep_tracking_master from "./Componet/Report/Rep_tracking_master";
import Allocate_allocate_vehicle_v3 from "./Componet/Allocation/Allocate_allocate_vehicle_v3";
import Allocate_finance from "./Componet/Allocation/Allocate_finance";
import Allocate_cost_approve_v3 from "./Componet/Allocation/Allocate_cost_approve_v3";
import Dashboard4 from "./Componet/Dashboard/Dashboard4";
import Follow_up_v2 from "./Componet/follow_up/Follow_up_v2";
import Follow_up_status_v2 from "./Componet/follow_up/Follow_up_status_v2";
import Dashboard5 from "./Componet/Dashboard/Dashboard5";
import Screen_1 from "./Componet/Report/Screen_1";
import Dashboard_status from "./Componet/Dashboard/Dashboard_status";
import Master_trip_2 from "./Componet/Report/Master_trip_2";
import Screen_2 from "./Componet/Report/Screen_2";
import Tracking from "./Componet/Report/Customer_Tracking";
import Follow_up_contoral from "./Componet/follow_up/Follow_up_contoral";
import Rep_tac from "./Componet/Report/Rep_tac";
import Public_dashboard from "./Componet/Public_Dashboard/Public_dashboard";

function App() {
    return (
        <>
            <BrowserRouter basename='/ntfms/'>
                <Switch>
                    <Route path="/" exact component={Welcome}/>
                    <Route path="/uti" exact component={Uti}/>
                    <Route path="/rag" exact component={RAG}/>
                    <Route path="/report" exact component={Report}/>
                    <Route path="/execute" exact component={Execute}/>
                    <Route path="/expire" exact component={Expire}/>
                    <Route path="/heading2" exact component={Heading2}/>
                    <Route path="/reportsevenday" exact component={Reportsevenday}/>
                    <Route path="/ordercu" exact component={OrderCU}/>

                    <Route path="/allocate" exact component={Allocate}/>
                    <Route path="/allocatecu" exact component={AllocateCU}/>

                    <Route path="/stoppage" exact component={Stoppage}/>
                    <Route path="/dashboard1" exact component={Dashboard1}/>
                    <Route path="/rvehiclestatus" exact component={Rvehiclestatus}/>
                    <Route path="/rordersummury" exact component={Rordersummury}/>


                    <Route path="/admin_transport" exact component={AMTransport}/>
                    <Route path="/admin_vehicle" exact component={AMVehicle}/>
                    <Route path="/admin_driver" exact component={AMDriver}/>
                    <Route path="/admin_trailer" exact component={AMTrailer}/>
                    <Route path="/admin_assignement" exact component={AMAssignment}/>
                    <Route path="/admin_location" exact component={AMLocation}/>
                    <Route path="/admin_road_route" exact component={AMRoadRoute}/>
                    <Route path="/admin_cargo" exact component={AMCargo}/>
                    <Route path="/admin_status" exact component={Status}/>

                    <Route path="/station" exact component={Station}/>
                    <Route path="/reporttest" exact component={Reporttest}/>

                    <Route path="/orderreport" exact component={OrderReport}/>
                    <Route path="/allocationreport" exact component={AllocationReport}/>
                    <Route path="/dashorder" exact component={DashOrder}/>
                    <Route path="/dashvehiclestatus" exact component={DashVehicleStatus}/>
                    <Route path="/frightreport" exact component={FrightReport}/>


                    <Route path="/dashboard1" exact component={Dashboard1}/>
                    <Route path="/dashboard2" exact component={Dashboard2}/>
                    <Route path="/dashboard3" exact component={Dashboard3}/>



                    <Route path="/type" exact component={Type}/>
                    <Route path="/login" exact component={Login}/>

                    <Route path="/user" exact component={User}/>
                    <Route path="/objuser" exact component={ObjUser}/>
                    <Route path="/useraccess1" exact component={UserAccess1}/>
                    <Route path="/useraccess2" exact component={UserAccess2}/>

                    <Route path="/order" exact component={Order}/>
                    <Route path="/order_change_date" exact component={Order_change_date}/>
                    <Route path="/order_change_cargo" exact component={Order_change_cargo}/>
                    <Route path="/order_change_volume" exact component={Order_change_volume}/>
                    <Route path="/order_change_sale_type" exact component={Order_change_sale_type}/>
                    <Route path="/allocate_allocate_vehicle" exact component={Allocate_allocate_vehicle}/>
                    <Route path="/allocate_unallocate_vehicle" exact component={Allocate_unallocate_vehicle}/>
                    <Route path="/allocate_date" exact component={Allocate_date}/>
                    <Route path="/allocate_cost_manage" exact component={Allocate_cost_manage}/>
                    <Route path="/allocate_cost_approval" exact component={Allocate_cost_approval}/>
                    <Route path="/allocate_cost_report" exact component={Allocate_cost_report}/>
                    <Route path="/allocate_weight" exact component={Allocate_weight}/>
                    <Route path="/allocate_unload" exact component={Allocate_unload}/>
                    <Route path="/allocate_extend_trip_req" exact component={Allocate_extend_trip_req}/>
                    <Route path="/allocate_extend_trip_approval" exact component={Allocate_extend_trip_approval}/>
                    <Route path="/allocate_extend_trip_report" exact component={Allocate_extend_trip_report}/>
                    <Route path="/follow_up_allocated_veh" exact component={Follow_up_allocated_veh}/>
                    <Route path="/follow_up_to_load_veh" exact component={Follow_up_to_load_veh}/>
                    <Route path="/follow_up_load_veh" exact component={Follow_up_load_veh}/>
                    <Route path="/follow_up_departure_veh" exact component={Follow_up_departure_veh}/>
                    <Route path="/follow_up_to_unload_veh" exact component={Follow_up_to_unload_veh}/>
                    <Route path="/follow_up_unload_veh" exact component={Follow_up_unload_veh}/>
                    <Route path="/open_order_status" exact component={Open_order_status}/>
                    <Route path="/close_order_status" exact component={Close_order_status}/>
                    <Route path="/allocation_status" exact component={Allocation_status}/>
                    <Route path="/movement_status" exact component={Movement_status}/>
                    <Route path="/movement_by_allocationveh" exact component={Movement_by_allocationveh}/>

                    <Route path="/allocate_allocate_vehicle_v2" exact component={Allocate_allocate_vehicle_v2}/>
                    <Route path="/allocate_cost_mgt_v2" exact component={Allocate_cost_mgt_v2}/>
                    <Route path="/allocate_cost_approve_v2" exact component={Allocate_cost_approve_v2}/>
                    <Route path="/follow_up_status" exact component={Follow_up_status}/>
                    <Route path="/follow_up_report" exact component={Follow_up_report}/>
                    <Route path="/date_v2" exact component={Date_V2}/>
                    <Route path="/allocate_change_route" exact component={Allocate_change_route}/>
                    <Route path="/follow_up_finish" exact component={Follow_up_finish}/>
                    <Route path="/rep_tracking_master" exact component={Rep_tracking_master}/>
                    <Route path="/rep_trip_master" exact component={Rep_trip_master}/>
                    <Route path="/allocate_allocate_vehicle_v3" exact component={Allocate_allocate_vehicle_v3}/>
                    <Route path="/allocate_finance" exact component={Allocate_finance}/>
                    <Route path="/allocate_cost_approve_v3" exact component={Allocate_cost_approve_v3}/>
                    <Route path="/dashboard4" exact component={Dashboard4}/>
                    <Route path="/follow_up_v2" exact component={Follow_up_v2}/>
                    <Route path="/follow_up_status_v2" exact component={Follow_up_status_v2}/>
                    <Route path="/dashboard5" exact component={Dashboard5}/>
                    <Route path="/screen_1" exact component={Screen_1}/>
                    <Route path="/dashboard_status" exact component={Dashboard_status}/>
                    <Route path="/master_trip_2" exact component={Master_trip_2}/>
                    <Route path="/screen_2" exact component={Screen_2}/>
                    <Route path="/customer_tracking" exact component={Tracking}/>

                    <Route path="/tracking" exact component={Tracking}/>
                    <Route path="/driver_point_by_trip" exact component={DPBTrip}/>
                    <Route path="/driver_point_by_vio" exact component={DPBVio}/>

                    <Route path="/follow_up_contoral" exact component={Follow_up_contoral}/>

                    <Route path="/rep_tac" exact component={Rep_tac}/>

                    <Route path="/public_dashboard" exact component={Public_dashboard}/>
                </Switch>
            </BrowserRouter>
        </>
    );
}

export default App;
